export enum CodeMessage {
  confirmIdentity = 'confirmIdentity',
  affiliateCell = 'affiliateCell',
  wrongWebKey = 'wrongWebKey',
  lockedWebKey = 'lockedWebKey',
  incorrectDataValidateCardAndDocument = 'incorrectDataValidateCardAndDocument',
  incorrectDataValidate = '22.01.07',
  errorFormatJwt = '22.01.02',
  lockedCard = '22.01.09',
  invalidJwt = '22.01.04',
  badRequestException = '01.03.04',
  suscriptionInvalid = '22.01.05',
  suscriptionBadBussiness = '22.01.08',
  informationInvalidRedis = '22.01.03',
  newLogin = 'newLogin',
  anotherUserHasConnected = 'anotherUserHasConnected',
  activeSession = 'activeSession',
  default = 'default',
  success = 'successLogin',
  successFA = 'successFactorAuthenticacion',
  errorLoadWeb = 'errorLoadWeb',
  errorLoadApp = 'errorLoadApp',
  activeExpiredSession = 'activeExpiredSession',
  expiredSessionWeb = 'expiredSessionWeb',
  expiredSessionApp = 'expiredSessionApp',
  failedRecatpcha = '22.01.06',
  authFromWeb = 'authFromWeb',
  authFromApp = 'authFromApp',
}

export const MESSAGES: any = {
  [CodeMessage.default]: {
    icon: './assets/icons/alert.svg',
    title: 'Lo sentimos',
    description:
      'Tu operación no ha podido ser realizada. Por favor, inténtalo más tarde.',
    button: 'Entendido',
  },
  [CodeMessage.success]: {
    icon: './assets/icons/success.svg',
    title: 'Tu solicitud de suscripción ha sido enviada.',
    description: '',
    button: 'Cerrar',
  },
  [CodeMessage.successFA]: {
    icon: './assets/icons/success.svg',
    title: 'Tu autenticación ha sido exitosa.',
    description: '',
    button: 'Cerrar',
  },
  [CodeMessage.errorLoadWeb]: {
    icon: './assets/icons/alert.svg',
    title: 'Sucedió algo inesperado',
    description: 'Por favor regresa a su aplicación web y vuelve a intentar.',
    button: 'Regresar',
  },
  [CodeMessage.errorLoadApp]: {
    icon: './assets/icons/alert.svg',
    title: 'Sucedió algo inesperado',
    description: 'Por favor regresa a su aplicativo móvil y vuelve a intentar.',
  },
  [CodeMessage.confirmIdentity]: {
    icon: './assets/icons/msg-scared.svg',
    title: 'Encontramos algo que queremos validar',
    description:
      'Para continuar con el proceso, necesitamos confirmar tu identidad. Por favor llámanos (211-8624)',
    button: 'Entendido',
  },
  [CodeMessage.affiliateCell]: {
    icon: './assets/icons/msg-danger.svg',
    title: 'Encontramos algo que queremos validar',
    description:
      'Tu celular aún no está afiliado a banca celular. Para culminar tu proceso de afiliación acércate a un cajero Global Net y selecciona la opción "Clave SMS" para poder afiliarlo.',
    button: 'Aceptar',
  },
  [CodeMessage.wrongWebKey]: {
    icon: './assets/icons/alert.svg',
    title: 'Lo sentimos',
    description:
      'Tu clave web es incorrecta. Por favor, verifica y vuelve a intentar',
    button: 'Aceptar',
  },
  [CodeMessage.incorrectDataValidateCardAndDocument]: {
    icon: './assets/icons/alert.svg',
    title: 'Lo sentimos',
    description:
      'Los datos ingresados son incorrectos. Por favor valida tu número de tarjeta y documento de identidad.',
    button: 'Entendido',
  },
  [CodeMessage.incorrectDataValidate]: {
    icon: './assets/icons/alert.svg',
    title: 'Lo sentimos',
    description: 'Los datos ingresados son incorrectos. Por favor verifícalos.',
    button: 'Entendido',
  },
  [CodeMessage.errorFormatJwt]: {
    icon: './assets/icons/msg-danger.svg',
    title: 'Lo sentimos',
    description:
      'Las credenciales son incorrectos. Por favor, verifícalos y vuelve a intentar.',
    button: 'Aceptar',
  },
  [CodeMessage.lockedCard]: {
    icon: './assets/icons/msg-block.png',
    title: 'Lo sentimos',
    description:
      'Lo sentimos, tu tarjeta se encuentra bloqueada. Por favor, comunícate con nuestra Banca Telefónica en Lima al 311-9000 y en provincias al 0-801-00802 para recibir mayor orientación.',
    button: 'Aceptar',
  },
  [CodeMessage.invalidJwt]: {
    icon: './assets/icons/msg-scared.svg',
    title: 'Lo sentimos',
    description:
      'Las credenciales internas son invalidos. Por favor, vuelve a intentar.',
    button: 'Aceptar',
  },
  [CodeMessage.badRequestException]: {
    icon: './assets/icons/alert.svg',
    title: 'Tenemos un inconveniente',
    description: 'No hemos podido conectar con el servidor',
    button: 'Aceptar',
  },
  [CodeMessage.suscriptionInvalid]: {
    icon: './assets/icons/alert.svg',
    title: 'Lo sentimos',
    description:
      'Lo sentimos, no hemos podido realizar tu operación. Estamos trabajando para solucionar el inconveniente.',
    button: 'Aceptar',
  },
  [CodeMessage.suscriptionBadBussiness]: {
    icon: './assets/icons/alert.svg',
    title: 'Lo sentimos',
    description:
      'Lo sentimos, tu operación no ha podido ser realizada. Estamos trabajando para solucionar el inconveniente.',
    button: 'Aceptar',
  },
  [CodeMessage.informationInvalidRedis]: {
    icon: './assets/icons/alert.svg',
    title: 'Lo sentimos',
    description: 'Lo sentimos, no hemos podido conectar con el servidor',
    button: 'Aceptar',
  },
  [CodeMessage.newLogin]: {
    icon: './assets/icons/msg-info.png',
    title: 'Nuevo inicio de sesión',
    description:
      'Tu sesión anterior se ha cerrado. Iniciaste sesión en este dispositivo',
    button: 'Aceptar',
  },
  [CodeMessage.anotherUserHasConnected]: {
    icon: './assets/icons/msg-info.png',
    title: 'Otro ususario se ha conectado',
    description:
      'Te has conectado dede otro dispositivo. Si no es así, debes cambiar tu contraseña cuanto antes aquí.',
    button: 'Aceptar',
  },
  [CodeMessage.activeSession]: {
    icon: './assets/icons/msg-info.png',
    title: 'Error',
    description:
      'Existe una sesión en este dispositivo. Cierra este tab o rediríjase al LOGIN para iniciar una nueva sesión.',
    button: 'Aceptar',
  },
  [CodeMessage.activeExpiredSession]: {
    icon: './assets/icons/time.png',
    title: 'Tu sesión está a punto de expirar',
    description: 'Tu sesión expira en 30 segundos.',
    button: 'Continuar',
  },
  [CodeMessage.expiredSessionWeb]: {
    icon: './assets/icons/time.png',
    title: 'Lo sentimos, tu sesión a expirado.',
    description: 'Regrese a su aplicación web y vuelve a intentar.',
    button: 'Salir',
  },
  [CodeMessage.expiredSessionApp]: {
    icon: './assets/icons/time.png',
    title: 'Lo sentimos, tu sesión a expirado.',
    description: 'Regrese a su aplicativo móvil y vuelve a intentar.',
  },
  [CodeMessage.failedRecatpcha]: {
    icon: './assets/icons/alert.svg',
    title: 'Acceso denegado',
    description:
      'Para continuar con el proceso, necesitamos confirmar tu identidad. Por favor llámanos (211-8624)',
    button: 'Entendido',
  },
  [CodeMessage.authFromWeb]: {
    icon: './assets/icons/msg-success.svg',
    title: 'Tu solicitud ha sido enviada satisfactoriamente.',
    description:
      'Por favor verifique su aplicación web. </br> Sesión finalizada.',
  },
  [CodeMessage.authFromApp]: {
    icon: './assets/icons/msg-success.svg',
    title: 'Tu solicitud ha sido enviada satisfactoriamente.',
    description:
      'Por favor verifique su aplicativo móvil. </br> Sesión finalizada.',
  },
};
